import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = unknown, false = unauthenticated
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/session")
      .then((r) => setUser(r.data?.user || false))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password) {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.mfa_required) {
        return { ok: true, mfa: { challengeId: data.challenge_id, sentTo: data.sent_to, emailFailed: data.email_failed } };
      }
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  }

  async function verify2fa(challengeId, code, remember) {
    try {
      const { data } = await api.post("/auth/verify-2fa", { challenge_id: challengeId, code, remember });
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  }

  async function resend2fa(challengeId) {
    try {
      const { data } = await api.post("/auth/resend-2fa", { challenge_id: challengeId });
      return { ok: true, sentTo: data.sent_to };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  }

  async function logout() {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setUser(false);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, verify2fa, resend2fa }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
